<template>
	<span
		:style="{
			color: word.probability < 0.4 && (showWordProbability || debugStore.debugMode) ? 'indianred' : undefined,
		}"
	>
		<v-tooltip
			:disabled="(!domainStore.isEditorOrAdmin || !showWordProbability) && !debugStore.debugMode"
			:text="(word.probability * 100).toFixed(0) + '%'"
		>
			<template v-slot:activator="{ props }">
				<span
					v-bind="props"
					:class="{ highlight: toHighlight.length > 0 }"
					:style="{ cursor: toHighlight.length > 0 ? 'pointer' : 'default' }"
					@click="onHighlightClick"
				>
					{{ word.value + " " }}
				</span>
			</template>
		</v-tooltip>
	</span>
</template>

<script setup lang="ts">
import { PropType, ref, onMounted, watch } from "vue";
import type { Word } from "@lr-notitia/notitia-alternis/schemas";
import { useAlternisStore } from "../../../../store/alternis";
import { useWorkerStore } from "../../../../store/worker";
import { useDomainStore } from "../../../../store/domain";
import { useDebugStore } from "../../../../store/debug";
import { useConfigStore } from "../../../../store/alternis/config";

const alternisStore = useAlternisStore();
const workerStore = useWorkerStore();
const domainStore = useDomainStore();
const debugStore = useDebugStore();
const configStore = useConfigStore();

let worker = ref<any>(null);
const showWordProbability = ref(false);

window.addEventListener("keydown", (e) => {
	if (e.altKey && domainStore.isEditorOrAdmin) showWordProbability.value = true;
});
window.addEventListener("keyup", (e) => {
	if (!e.altKey) showWordProbability.value = false;
});

const compProps = defineProps({
	word: {
		type: Object as PropType<Word>,
		required: true,
	},
});

const toHighlight = ref<string[]>([]);

function onHighlightClick() {
	if (toHighlight.value.length === 0) return;
	alternisStore.clickedHighlightAttributes = toHighlight.value;
	alternisStore.clickedHighlightWord = compProps.word.value;
}
function cleanedString(text: string): string {
	return text.toLowerCase().replace(/[^a-z0-9äöüÄÖÜßçış]/g, "");
}

function postWorker() {
	if (cleanedString(compProps.word.value).length === 0) return;
	worker.value.postMessage({ text: compProps.word.value, highlights: alternisStore.highlights });
}

watch(
	() => worker.value,
	() => {
		if (worker.value) {
			postWorker();
		}
	}
);

onMounted(async () => {
	if (configStore.wordHighlighting) {
		worker.value = await workerStore.spawn("highlight");
		worker.value.addEventListener("message", (event: any) => {
			toHighlight.value = event.data.result;
			worker.value.terminate();
			workerStore.releaseWorker("highlight"); // Release the worker when done
		});
	}
});
</script>

<style scoped lang="scss">
.highlight {
	padding-left: 0.15em;
	padding-right: 0.15em;
	border-radius: 0.25em;
	background-color: #ffb74da0;
}
</style>
